__turbopack_context__.v({
  "baseRotate": "qxbY4G_baseRotate",
  "core": "qxbY4G_core",
  "particle": "qxbY4G_particle",
  "root": "qxbY4G_root",
  "rotating": "qxbY4G_rotating",
  "stage": "qxbY4G_stage",
});
